import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { MagnifyingGlassIcon, XCircleFilledIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

const countableFilters = ['searchExpression', 'setId', 'tags'];

const SearchFilterButton = ({
  filters,
  filtersOpen,
  disabled,
  clearFilters,
  onClick,
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const filtersCount = useMemo(
    () =>
      Object.keys(filters).filter((key) => countableFilters.includes(key))
        .length,
    [filters],
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: '12px',
        border: `1px solid ${theme.colors.charcoal400}`,
        borderRadius: '2px',
      }}
    >
      <Button
        style={{
          border: 'none',
          borderRadius: 0,
          ...(!filtersOpen && {
            '&:hover': {
              background: theme.colors.charcoal050,
              color: theme.colors.charcoal900,
            },
          }),
        }}
        selected={filtersOpen}
        renderIcon={({ ...p }) => <MagnifyingGlassIcon {...p} />}
        onClick={onClick}
        disabled={disabled}
      >
        {T.translate(
          filtersCount ? 'SEARCH_AND_FILTER_WITH_COUNT' : 'SEARCH_AND_FILTER',
          {
            count: filtersCount,
          },
        )}
      </Button>
      {!!filtersCount && (
        <Tooltip content={T.translate('CLEAR_SEARCH_AND_FILTER')}>
          <Button
            style={{
              border: 'none',
              borderLeft: `1px solid ${theme.colors.charcoal400}`,
              borderRadius: 0,
              ...(!filtersOpen && {
                '&:hover': {
                  background: theme.colors.charcoal050,
                  color: theme.colors.charcoal900,
                },
              }),
            }}
            renderIcon={(p) => <XCircleFilledIcon {...p} />}
            onClick={clearFilters}
          />
        </Tooltip>
      )}
    </div>
  );
};

SearchFilterButton.propTypes = {
  /**
   * The currently applied filters.
   */
  filters: PropTypes.object,
  /**
   * Whether or not filter panel is open.
   */
  filtersOpen: PropTypes.bool.isRequired,
  /**
   * Disable button functionality
   */
  disabled: PropTypes.bool,
  /**
   * Callback to clear filters.
   */
  clearFilters: PropTypes.func,
  /**
   * Callback to toggle filter panel open/close.
   */
  onClick: PropTypes.func.isRequired,
};

export default SearchFilterButton;
